import React from "react";
import { Input, Segment } from "semantic-ui-react";
import parse from "html-react-parser";

interface Props {
  questionHeading: string;
  invalid: boolean;
  value: string | null | undefined;
  onValueChange: (value: number, text: string) => void;
}

export default function TextQuestionControl({ questionHeading, onValueChange, invalid, value }: Props) {
  return (
    <>
      <div className={invalid?"negative-message":"question-wrapper"}>
      <label className="statement">{parse(questionHeading)}</label>
      <Segment className="survey-answers inputq">
      <textarea name="Text1" rows={3} cols={40} value={value && value != "" ? value : ""}
          onChange={(e) => {
            onValueChange(0, e.target.value);
              }}
            />
      </Segment>
      </div>
    </>
  );
}
